import script from "./urlopen.vue?vue&type=script&lang=js"
export * from "./urlopen.vue?vue&type=script&lang=js"

const __exports__ = script;

export default __exports__